// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2222 ? "4e9979e5" : chunkId) + "." + {"2222":"5265e7ddfd69f87b","5677":"be349887708051d3"}[chunkId] + ".js";
};